import React, { ReactElement } from 'react';
import { YesOrNoStepCreator } from '../../shared/YesOrNoStepCreator/YesOrNoStepCreator';
import { NavigationButtons } from '../../shared/NavigationButtons/NavigationButtons';
import { Formik, Form } from 'formik';
import { CoverageCheckupState, goToNextStep, updateCoverageCheckupState } from '../../../store/step';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { createYesNoObjectSchema } from '../../schema/yesNoNotSureSchema';
import { CardPadding, GrayCard, GrayCardHeader } from '../../shared/CardStyles';
import { CardHeader } from '../../shared/CardStyles/CardHeader';
import { useFormInteractionTracking } from '../../../hooks/useFormInteractionTracking';

function IdentityTheftProtectionStep(): ReactElement {
  const dispatch = useDispatch();
  const { identityTheftProtectionPossessed: identityTheftProtectionPossessed } =
    useSelector((state: RootState) => state.steps);

  const formRef = useFormInteractionTracking('have_idtp');

  function onSubmit(values: Partial<CoverageCheckupState>): void {
    dispatch(updateCoverageCheckupState(values));
    dispatch(goToNextStep());
  }

  return (
    <>
      <GrayCard>
        <GrayCardHeader
          header="Identity Theft Protection"
          subHeader="Identity theft protection cleans up the mess for you if your identity gets
          stolen."
        />
      </GrayCard>
      <CardPadding>
        <CardHeader
          header="Do you have an identity theft protection plan?"
          subHeader=""
        />
        <Formik
          initialValues={{ identityTheftProtectionPossessed }}
          onSubmit={onSubmit}
          validationSchema={createYesNoObjectSchema(
            'identityTheftProtectionPossessed'
          )}
        >
          <Form ref={formRef}>
            <YesOrNoStepCreator
              name="identityTheftProtectionPossessed"
              showNotSure={true}
            />

            <NavigationButtons />
          </Form>
        </Formik>
      </CardPadding>
    </>
  );
}

export { IdentityTheftProtectionStep };
